import { Grid } from 'semantic-ui-react';

import Home from '../components/home';
import { useTabContext } from '../contexts/TabContext';

export default function App() {
  const { tab, setTab, setActiveAlertsCount } = useTabContext();

  return (
    <Grid cols={1} padded={'horizontally'}>
      <Grid.Row>
        <Home tab={tab} setTab={setTab} setActiveAlertsCount={setActiveAlertsCount} />
      </Grid.Row>
    </Grid>
  );
}
